<script>
import Layout from '../../layouts/main';
import PageHeader from '@/components/page-header';
import CustomerService from '@/services/customer';
import { VMoney } from 'v-money';

export default {
  page: {
    title: 'Produto',
  },
  components: { Layout, PageHeader },
  directives: { money: VMoney },
  data() {
    return {
      customer: {
        address: {},
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false,
      },
    };
  },
  methods: {
    saveCustomer() {},
    saveSettings() {
      let loader = this.$loading.show();

      const data = {
        _id: this.customer._id,
        discount: this.customer.discount ? this.customer.discount.toString().replace('.', '').replace(',', '.') : null,
      };

      CustomerService.saveCustomer(data)
        .then(() => {
          this.$forceUpdate();

          loader.hide();

          this.$toast.open('Dados atualizados');
        })
        .catch((err) => {
          this.$toast.error(err);
          loader.hide();
        });
    },

    formatCustomerData(data) {
      return {
        ...data,
        discount: (data.discount || 0).toFixed(2).replace('.', ','),
      }
    }
  },

  async mounted() {
    let loader = this.$loading.show();

    try {
      const customerData = await CustomerService.getCustomer(
        this.$route.params.id
      );
      this.customer = this.formatCustomerData(customerData.data);

      loader.hide();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err)

      this.$toast.error('Ocorreu um erro inesperado');
      loader.hide();
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader title="Dados do Cliente" />

    <div class="checkout-tabs" v-if="customer">
      <b-tabs pills vertical nav-class="p-0" nav-wrapper-class="col-lg-2 w-100">
        <b-tab active>
          <template v-slot:title>
            <i class="bx bx-user d-block check-nav-icon mt-4 mb-2"></i>
            <p class="font-weight-bold mb-4">Dados Principais</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <!-- <h4 class="card-title">Dados do Cliente</h4> -->
                <!-- <p class="card-title-desc">Preencha os dados</p> -->
                <form>
                  <div class="row">
                    <div class="col-sm-5">
                      <div class="form-group">
                        <label for="name">Nome/Razão Social</label>
                        <input
                          id="name"
                          name="name"
                          type="text"
                          class="form-control"
                          v-model="customer.name"
                          disabled
                        />
                      </div>
                    </div>

                    <div class="col-sm-3" v-if="customer.document_number.length < 12">
                      <div class="form-group">
                        <label for="document_number">CPF</label>

                        <input
                          v-model="customer.document_number"
                          v-mask="'###.###.###-##'"
                          type="text"
                          class="form-control"
                          disabled
                        />
                      </div>
                    </div>

                    <div class="col-sm-3" v-if="customer.document_number.length > 12">
                      <div class="form-group">
                        <label for="document_number">CNPJ</label>

                        <input
                          v-model="customer.document_number"
                          v-mask="'##.###.###/####-##'"
                          type="text"
                          class="form-control"
                          disabled
                        />
                      </div>
                    </div>

                    <div class="col-sm-2">
                      <div class="form-group">
                        <label for="state_register">Inscrição Estadual</label>

                        <input
                          v-model="customer.state_register"
                          type="text"
                          class="form-control"
                          disabled
                        />
                      </div>
                    </div>

                    <div class="col-sm-2">
                      <div class="form-group">
                        <label for="phone_number">Telefone</label>
                        <input
                          id="phone_number"
                          name="phone_number"
                          type="text"
                          class="form-control"
                          v-model="customer.phone_number"
                          disabled
                        />
                      </div>
                    </div>

                    <div class="col-sm-2">
                      <div class="form-group">
                        <label for="zipcode">CEP</label>
                        <input
                          id="zipcode"
                          name="zipcode"
                          v-mask="'#####-###'"
                          type="text"
                          class="form-control"
                          v-model="customer.address.zipcode"
                          disabled
                        />
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <div class="form-group">
                        <label for="street">Endereço</label>
                        <input
                          id="street"
                          name="street"
                          type="text"
                          class="form-control"
                          v-model="customer.address.street"
                          disabled
                        />
                      </div>
                    </div>

                    <div class="col-sm-1">
                      <div class="form-group">
                        <label for="number">Número</label>
                        <input
                          id="number"
                          name="number"
                          type="text"
                          class="form-control"
                          v-model="customer.address.number"
                          disabled
                        />
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <div class="form-group">
                        <label for="city">Cidade</label>
                        <input
                          id="city"
                          name="city"
                          type="text"
                          class="form-control"
                          v-model="customer.address.city"
                          disabled
                        />
                      </div>
                    </div>

                    <div class="col-sm-1">
                      <div class="form-group">
                        <label for="state">UF</label>
                        <input
                          id="state"
                          name="state"
                          type="text"
                          class="form-control"
                          v-model="customer.address.state"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div class="row mt-4 align-items-center">
              <div class="col-sm-6">
                <router-link
                  tag="a"
                  to="/customers"
                  class="btn text-muted d-none d-sm-inline-block btn-link"
                >
                  <i class="mdi mdi-arrow-left mr-1"></i> Voltar para lista de
                  clientes
                </router-link>
              </div>

              <!-- <div class="col-sm-6">
                <div class="text-sm-right">
                  <button
                    type="button"
                    class="btn btn-primary btn-rounded mb-2 mr-2"
                    @click="saveCustomer"
                  >
                    <i class="mdi mdi-check mr-1"></i> Salvar Dados do Cliente
                  </button>
                </div>
              </div> -->
            </div>
          </b-card-text>
        </b-tab>

        <b-tab>
          <template v-slot:title>
            <i class="bx bx-cog d-block check-nav-icon mt-4 mb-2"></i>
            <p class="font-weight-bold mb-4">Parametrização</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <form>
                  <div class="row">
                    <div class="col-sm-2">
                      <div class="form-group">
                        <label for="discount">Desconto</label>

                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">%</span>
                          </div>
                          <input
                            id="discount"
                            name="discount"
                            class="form-control"
                            v-model="customer.discount"
                            v-money="money"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div class="row mt-4 align-items-center">
              <div class="col-sm-6">
                <router-link
                  tag="a"
                  to="/customers"
                  class="btn text-muted d-none d-sm-inline-block btn-link"
                >
                  <i class="mdi mdi-arrow-left mr-1"></i> Voltar para lista de
                  clientes
                </router-link>
              </div>

              <div class="col-sm-6">
                <div class="text-sm-right">
                  <!-- <b-spinner class="m-2" variant="primary" role="status" v-if="loading"></b-spinner> -->
                  <button
                    type="button"
                    class="btn btn-primary btn-rounded mb-2 mr-2"
                    @click="saveSettings"
                  >
                    <i class="mdi mdi-check mr-1"></i> Salvar Dados do Cliente
                  </button>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </div>
  </Layout>
</template>

<style lang="scss">
  .nav-link.disabled {
    color: #e1e1e1;
  }
</style>
